// if the module has no dependencies, the above pattern can be simplified to
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['xpath'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('xpath'));
    } else {
        // Browser globals (root is window)
        root.FVNamespaceResolver = factory(root.xpath);
    }
}(typeof self !== 'undefined' ? self : this, function (xpath) {
    var NamespaceResolver = xpath.NamespaceResolver;

    function FVNamespaceResolver() {
        var namespaces = {};

        this.addNamespace = function (prefix, uri) {
            namespaces[prefix] = uri;
        };

        this.lookupNamespaceURI = function (prefix, context) {
            var found = namespaces[prefix];

            found = found || (context && this.superclass.getNamespace(prefix, context));

            return found || null;
        };

        this.getNamespace = this.lookupNamespaceURI;
    }

    FVNamespaceResolver.prototype = new NamespaceResolver();
    FVNamespaceResolver.prototype.constructor = FVNamespaceResolver;
    FVNamespaceResolver.prototype.superclass = NamespaceResolver.prototype;

    return FVNamespaceResolver;
}));